import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";
import StoriesService from "../../services/StoriesService";

const SpecialFeatures = () => {
  const [active, setActive] = useState("Download document");
  const [siteSetting, setSiteSetting] = useState({});

  const [stories, setStories] = useState([]);

  const getSiteSetting = async () => {
    try {
      const response = null;
      if (response) {
        setSiteSetting(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllStories = async () => {
    try {
      const response = await StoriesService.getStories();
      if (response) {
        setStories(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const saveSpecialFeatures = async (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    var object = {};
    data.forEach(function (value, key) {
      object[key] = value;
    });

    if (active == "Download document") {
      if (object.download == "on") {
        object.download = true;
      } else {
        object.download = false;
      }
    }
    if (active == "Share website") {
      if (object.share == "on") {
        object.share = true;
      } else {
        object.share = false;
      }
    }
    if (active == "Messaging center") {
      if (object.messaging == "on") {
        object.messaging = true;
      } else {
        object.messaging = false;
      }
    }
    const response = null;
    if (response) {
      getSiteSetting();
      toast.success("Saved changes");
    }

    try {
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    getSiteSetting();
    getAllStories();
  }, []);

  return (
    <div className="container">
      <div className="overview">
        <div className="title">
          <ion-icon name="cloud-download-outline"></ion-icon>
          <span className="text">Special Features</span>
        </div>
      </div>

      <div className="d-flex">
        <div
          onClick={() => setActive("Download document")}
          className={`pb-2 usersNav ${
            active == "Download document" && "usersNav-active"
          }`}
        >
          Download document
        </div>
        <div
          onClick={() => setActive("Share website")}
          className={`ms-4 usersNav ${
            active == "Share website" && "usersNav-active"
          }`}
        >
          Share website
        </div>
        <div
          onClick={() => setActive("Messaging center")}
          className={`ms-4 usersNav ${
            active == "Messaging center" && "usersNav-active"
          }`}
        >
          Messaging center
        </div>
      </div>

      {active == "Download document" && (
        <form onSubmit={saveSpecialFeatures}>
          <div style={{ width: "520px" }}>
            <div className="mt-5 pt-5 d-flex">
              <label className="col-form-label">Enable Download Document</label>
              <label className="switch mt-2 ms-auto">
                <input
                  name="download"
                  type="checkbox"
                  defaultChecked={siteSetting?.downloadDocument?.download}
                />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="mt-4 themeColor">
              <label>Label</label>
              <input
                style={{ width: "100%" }}
                name="label"
                type="text"
                className="form-control truncate mt-2 ps-3"
                id="recipient-name"
                placeholder="Enter label name here..."
                defaultValue={siteSetting?.downloadDocument?.label}
              />
            </div>

            <div className="mt-3 themeColor">
              <label>Select story</label>

              <select
                name="downloadStory"
                className="form-select mt-2"
                aria-label="Default select example"
                defaultValue={siteSetting?.downloadDocument?.downloadStory}
              >
                {stories.map((story, index) => (
                  <option key={index} value={story?._id}>
                    {story?.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="mt-3 themeColor">
              <label>Download link</label>
              <input
                style={{ width: "100%" }}
                name="downloadLink"
                type="text"
                className="form-control truncate mt-2 ps-3"
                id="recipient-name"
                placeholder="Enter download link here..."
                value={siteSetting?.downloadDocument?.downloadLink}
              />
            </div>

            <button id="site-setting" className="btn-model mt-5" type="submit">
              Save Changes
            </button>
          </div>
        </form>
      )}

      {active == "Share website" && (
        <form onSubmit={saveSpecialFeatures}>
          <div style={{ width: "520px" }}>
            <div className="mt-5 pt-5 d-flex">
              <label className="col-form-label">Enable Share website</label>
              <label className="switch mt-2 ms-auto">
                <input
                  name="share"
                  type="checkbox"
                  defaultChecked={siteSetting?.shareWebsite?.share}
                />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="mt-3 themeColor">
              <label>Select story</label>
              <select
                name="shareWebsiteStory"
                className="form-select mt-2"
                aria-label="Default select example"
                defaultValue={siteSetting?.shareWebsite?.shareWebsiteStory}
              >
                {stories.map((story, index) => (
                  <option key={index} value={story?._id}>
                    {story?.title}
                  </option>
                ))}
              </select>
            </div>

            <button id="site-setting" className="btn-model mt-5" type="submit">
              Save Changes
            </button>
          </div>
        </form>
      )}

      {active == "Messaging center" && (
        <form onSubmit={saveSpecialFeatures}>
          <div style={{ width: "520px" }}>
            <div className="mt-5 pt-5 d-flex">
              <label className="col-form-label">Enable Messaging Center</label>
              <label className="switch mt-2 ms-auto">
                <input
                  name="messaging"
                  type="checkbox"
                  defaultChecked={siteSetting?.messagingCenter?.messaging}
                />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="mt-3 themeColor">
              <label>Select story</label>
              <select
                name="messagingStory"
                className="form-select mt-2"
                aria-label="Default select example"
                defaultValue={siteSetting?.messagingCenter?.messagingStory}
              >
                {stories.map((story, index) => (
                  <option key={index} value={story?._id}>
                    {story?.title}
                  </option>
                ))}
              </select>
            </div>

            <button id="site-setting" className="btn-model mt-5" type="submit">
              Save Changes
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default SpecialFeatures;
